import { isMoment } from 'moment';

/**
 * Validate that object contains a set of properties
 * @param obj Any object
 * @param props Array with props to validate in object
 */
export function ObjHasProperties(obj: object, props: string[]): boolean {
  const keys = Object.keys(obj);

  for (const key of keys) {
    if (!props.includes(key)) {
      return false;
    }
  }

  return true;
}

/**
 * Deep-delete object properties conditionally. Removes false or empty strings by default.
 * @param obj Any object with any depth level.
 * @param shouldRemove Boolean function to check which elements should get deleted
 */
export function DeleteObjectProperties(
  obj: any,
  shouldRemove: (e: any) => boolean = (e: any) =>
    !isMoment(e) &&
    (e === null ||
      e === undefined ||
      e === '' ||
      (typeof e === 'object' && Object.keys(e).length === 0))
): void {
  try {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const element = obj[key];

        if (typeof element === 'object') {
          DeleteObjectProperties(element, shouldRemove);
        }

        if (shouldRemove(element)) {
          delete obj[key];
        }
      }
    }
  } catch (error) {
    console.error('Delete object properties: ', error);
  }
}
